import { useQuery } from "@tanstack/react-query";
import {
  getAdminAccessToken,
  getOwnerAccessToken,
  getStoreAccessToken,
  getStoreId,
} from "../../utils/auth";
import { fetcher } from "../../utils/fetchers";
import { StoreActionType } from "../../types/modules/storeAction.type";

export const useSingleStoreAction = (numericStoreId: number | undefined) => {
  const storeId = numericStoreId ? numericStoreId : getStoreId();
  const token = numericStoreId ? getAdminAccessToken() : getStoreAccessToken();
  return useQuery({
    queryKey: ["store-detail-action", storeId],
    queryFn: () =>
      fetcher<StoreActionType>(
        `store/action/current?storeId=${storeId}`,
        token
      ),
    enabled: !!storeId,
  });
};

export const useInCompleteStore = (ownerId?: number) => {
  const token = ownerId ? getAdminAccessToken() : getOwnerAccessToken();
  const endPoint = ownerId
    ? `store/incomplete?ownerId=${ownerId}`
    : `store/incomplete`;
  return useQuery({
    queryKey: ["store-incomplete", token, ownerId],
    queryFn: () =>
      fetcher<{
        hasIncompleteStore: boolean;
        store?: {
          languages: { languageCode: string; brand: string }[];
          sector: {
            id: number;
            languages: { languageCode: string; name: string }[];
          };
        };
      }>(endPoint, token),
  });
};
